// Mirrors ResaleListing::MINIMUM_LIST_PRICE_CENTS. Below it adjust_for_absorbing returns
// zeros — buyer charged $0.00, seller paid $0.00, seat consumed — so the server refuses it
// and the wizard must not quote one. resale_listing_test.rb reads this file and asserts
// the two numbers match.
export const MINIMUM_LIST_PRICE_CENTS = 50;
